export const mimeTypes: any = {
	'xls': 'application/vnd.ms-excel',
	'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'xml': 'application/xml',
	'zip': 'application/zip',
	'java': 'text/plain',
	'log': 'text/plain',
	'txt': 'text/plain',
	'csv': 'text/csv',
	'bpmn': 'application/xml',
	'doc': 'application/msword',
	'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'dotx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
	'xltx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
	'ppt': 'application/vnd.ms-powerpoint',
	'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	'potx': 'application/vnd.openxmlformats-officedocument.presentationml.template',
	'ppsx': 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
	'pdf': 'application/pdf',
	'html': 'text/html',
	'jpeg': 'image/jpeg',
	'jpg': 'image/jpeg',
	'jfif': 'image/jpeg',
	'png': 'image/png',
	'gif': 'image/gif',
	'svg': 'image/svg+xml',
	'bmp': 'image/bmp',
	'tiff': 'image/tiff',
	'tif': 'image/tiff',
	'webp': 'image/webp',
	'ico': 'image/x-icon',
	'heic': 'image/heic',
	'avif': 'image/avif',
	'json': 'application/json',
	'mp4': 'video/mp4',
	'mp3': 'audio/mpeg',
	'wav': 'audio/wav',
	'avi': 'video/x-msvideo',
	'mov': 'video/quicktime',
	'mpg': 'video/mpeg',
	'webm': 'video/webm',
	'_default': 'application/octet-stream'
};

export const imagesMimeTypes = Object.keys(mimeTypes).reduce((acc: any, next) => {
	if (mimeTypes[next].indexOf('image') !== -1) { acc[next] = 1; }
	return acc;
}, {});

export const videoMimeFiles = Object.keys(mimeTypes).reduce((acc: any, next) => {
	if (mimeTypes[next].indexOf('video') !== -1) { acc[next] = 1; }
	return acc;
}, {});
